export default "__VITE_ASSET__rTw$n82f__";